import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["height", "width"];
let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingSkeletonLegacy = styledWithTheme.div.attrs({
  'data-loading': true,
  'data-test-id': 'marketing-platform-skeleton'
})(_t || (_t = _`
  @keyframes pulse {
    from {
      background-color: ${0};
    }
    to {
      background-color: ${0};
    }
  }

  background-color: ${0};
  border-radius: ${0};
  animation: 2s ease-in-out 0s infinite alternate both running pulse;

  @media (prefers-reduced-motion) {
    animation: none;
  }
`), ({
  theme: {
    color
  }
}) => color['fill-field-disabled'], ({
  theme: {
    color
  }
}) => color['fill-tertiary-pressed'], ({
  theme: {
    color
  }
}) => color['fill-field-disabled'], ({
  theme: {
    borderRadius
  }
}) => borderRadius['200']);

/**
 * Styled component with transient $cssStyles applied.
 * @see https://product.hubteam.com/docs/trellis-migration-guide/static/component-internals.html
 */
const TransitionalLoadingSkeleton = styledWithTheme(LoadingSkeletonLegacy)(({
  $cssStyles
}) => Object.assign({}, $cssStyles));
export const LoadingSkeleton = _ref => {
  let {
      height,
      width
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  /**
   * Legacy props can be removed once all downstream consumers are migrated.
   * @deprecated (Trellis) use accepted space and size token props
   */
  const legacyProps = {
    height,
    width
  };

  /**
   * - domProps: DOM props (e.g. `role`, `data-*` attributes, event handlers, etc.)
   * - tokenProps: Trellis props
   * @see https://product.hubteam.com/docs/trellis-migration-guide/static/component-internals.html
   */
  const {
    domProps,
    tokenProps
  } = filterProps(rest);

  /**
   * CSS style object passed directly to styled component. Can be a mix of
   * legacy and Trellis props until all downstream consumers are migrated.
   *
   * @example { height: 24, inlineSize: '130px' }
   * @see https://product.hubteam.com/docs/trellis-migration-guide/static/component-internals.html
   */
  const cssStyles = useMapTokenPropsToCSS(Object.assign({}, legacyProps, tokenProps));
  return /*#__PURE__*/_jsx(TransitionalLoadingSkeleton
  // Standard DOM props plus CSS props passed to styled component
  , Object.assign({}, domProps, {
    $cssStyles: cssStyles
  }));
};
export default LoadingSkeleton;